import { Component, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-diary-print-modal',
  templateUrl: './diary-print-modal.component.html',
  styleUrls: ['./diary-print-modal.component.scss'],
})
export class DiaryPrintModalComponent {
  @Output() result = new EventEmitter<
    | {
        withEncouragements: boolean;
        withImages: boolean;
      }
    | undefined
  >();
  withEncouragements = true;
  withImages = true;

  constructor(private bsModalRef: BsModalRef) {
    // Nada
  }

  validate() {
    this.result.emit({
      withEncouragements: this.withEncouragements,
      withImages: this.withImages,
    });
    this.bsModalRef.hide();
  }

  hideModal() {
    this.result.emit(undefined);
    this.bsModalRef.hide();
  }
}
